import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Message, User, Proffesional } from '../model/dto';
import {UserModel} from '../model/user.model';
import { Router } from '@angular/router';
import {BaseModel} from '../model/base.model';
import * as $ from 'jquery';

@Component({
  selector: 'app-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.css']
})
export class MessageListComponent implements OnInit {

  public received:Message[];
  public sent:Message[];
  public pages:number[];
  public currentPage:number = 1;
  public total:number = 1;
  public filterName:string = 'Select filter';
  public filterValue:string = '';
  public isCollapsed:boolean = true;
  public isMAsearchCollapsed:boolean = true;
  public user:User;
  public adminLists:object[];
  public selLista:number;
  public ckeditorContent:string;
  public subject:string;
  public proffesionals:Proffesional[];
  public specialties:object;
  public profToDel:number[];
  protected checkAllBoxes:boolean = false;
  
  constructor(private _api:ApiService, private _userModel:UserModel) {
    this.user = this._userModel.user;
   }

  ngOnInit() {
  	this._api.getMessages(1, this.user.PkUser)
  		.subscribe(result => this.onMessages(result)); 
     this._api.getLists(this.user.PkUser)
        .subscribe(result=>this.onLists(result))
     this._api.getSpecialties()
      .subscribe(result => this.onSpecialties(result));   
  }

  onLists(data:object){
    this.adminLists = []
    var tot = data['length']
    var cant:number = 0;
    for (var i = 0; i < tot; i++) {
     cant = data[i]['members']['length']
     this.adminLists.push({label:data[i].Name+'('+cant+')', value:data[i].PkList});
    }
  }

   onSpecialties(data:object){
    this.specialties = {};
    for(var i:number = 0; i<data['length']; i++){
      this.specialties[data[i]['PkSpecialty']] = data[i]['Name'];
    }   
  }

  onListSelect(){
    this._api.getListMembers(this.selLista)
      .subscribe(result=>this.onProffesionals(result))
  }

  onProffesionals(data:object){
    this.proffesionals = [];
    this.total = parseInt(data['last_page']);
    this.currentPage = parseInt(data['current_page']);
    this.pages = [];
    var item:string;
    var proffesional:Proffesional
    for (var i = 0; i<this.total; i++) this.pages.push(i+1);
     // console.log('Encuentra '+ data['data']['length']);
    for (i = 0; i < data['data']['length']; i++) {
      proffesional = data['data'][i] as Proffesional;
      proffesional.SpecialtyName = '';
      for (var z = 0; z < proffesional.specialty.length; z++) {
         item = this.specialties[proffesional.specialty[z]['FkSpecialty']] as string;
         proffesional.SpecialtyName += item+', '         
      }
     proffesional.SpecialtyName = proffesional.SpecialtyName.substr(0, proffesional.SpecialtyName.length-2);
      this.proffesionals.push(proffesional);
    }
  }

  onMessages(data:object){
  	this.received = [];
    this.sent = [];
  	for (var i = 0; i < data['from']['length']; i++) {
  		var msg:Message = data['from'][i] as Message; 
      if(msg.touser.FkType==1){
        var name:string = msg.touser['proffesional']['FirstName']+' '+msg.touser['proffesional']['LastName']       
        msg.Label = "To: "+name
      } else if(msg.touser.FkType==2){
        var name:string = msg.touser['office']['Name'];
        msg.Label = "To: "+name
      }
  		this.sent.push(msg);
  	}
   
    for (var i = 0; i < data['to']['length']; i++) {
      var msg:Message = data['to'][i] as Message;
      if(msg.fromuser.FkType==1){
        var name:string = msg.fromuser['proffesional']['FirstName']+' '+msg.fromuser['proffesional']['LastName']       
        msg.Label = 'From: '+name
      } else if(msg.fromuser.FkType==2){
        var name:string = msg.fromuser['office']['Name'];
        msg.Label = 'From: '+name
      }
      this.received.push(msg);
    }
  }

   loadPage(page:number){
  		this._api.getMessages(page, this.user.PkUser)
  			.subscribe(result => this.onMessages(result));
  }

  filter(label:string){
    switch (label) {
      case "all":
        // code...
        break;
      case "sended":
        // code...
        break;
      case "received":
        // code...
        break;
      default:
        // code...
        break;
    }
  }
  
  checkAll(){
    this.checkAllBoxes = !this.checkAllBoxes;
    var tot:number = this.proffesionals.length
    for (var i = 0; i < tot; i++) {
      $('#'+this.proffesionals[i].PkProffesional).prop('checked', this.checkAllBoxes);
    }
  }

  public sendContent(){
    //console.log(this.ckeditorContent);    
    this._api.sendMassMail(this.selLista, this.ckeditorContent, this.subject)
      .subscribe(result=>this.onMailing(result))
  }

  removeFromList(){
    var tot:number = this.proffesionals.length
    this.profToDel = [];
    for (var i = 0; i < tot; i++) {
      if($('#'+this.proffesionals[i].PkProffesional).prop('checked')) this.profToDel.push(this.proffesionals[i].PkProffesional);
    }
    if(confirm('Are you sure to delete this profesionals from the list?')){      
      this._api.removeFromList(this.selLista, this.profToDel)
        .subscribe(result=>this.onProffesionals(result))
      this._api.getLists(this.user.PkUser)
        .subscribe(result=>this.onLists(result))       
    }
  }

  public onMailing(data:object){
    alert('Mail sent !');
  }

  public onChange(evt){}
  public onEditorChange(evt){}
  public onReady(evt){}
  public onFocus(evt){}
  public onBlur(evt){}
  public onContentDom(evt){}
  public onPaste(evt){}
  public onDrop(evt){}
}
